import { isGecko } from 'src/js/lib/snif.js';
import { fadeIn } from 'src/js/run/frame.js';
import { appear } from 'src/js/run/ghost.js';
import accord from 'src/js/run/accord.js';
import thread from 'src/js/run/thread.js';
import page from 'src/js/run/page.js';

const active = async function () {
  await fadeIn( 30 );
  await appear();
  accord();
  await thread();
  page();
};

// Rendering engine detection
try
{
  if ( isGecko() )
  {
    document.documentElement.classList.add( 'snif-gecko' );
  }
}
catch ( e )
{
  console.log( e );
}

// All js action activation
try
{
  Typekit.load( { active } );
}
catch ( e )
{
  active();
}
